/* Panoul „Filtrează și sortează” (mobil):
   1. La închidere, focusul revine pe controlul care l-a deschis
      (summary-ul din <facet-drawer>).
   2. „Șterge” din bara de jos a panoului golește filtrele și apoi închide
      panoul, la fel ca „Aplică”. „Șterge” din fiecare filtru rămâne ca în temă.
   Tema trimite focusul pe opener doar la Esc; la X, tap pe overlay sau după
   re-randarea filtrelor focusul rămânea pe butonul din panou sau pe <body>.
   Nu mută focusul dacă utilizatorul l-a dus deja în altă parte a paginii. */
(function () {
  function opener() {
    var all = document.querySelectorAll('facet-drawer > details > summary');
    for (var i = 0; i < all.length; i++) {
      var r = all[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return all[i];
    }
    return all[0] || null;
  }

  function focusLost() {
    var a = document.activeElement;
    if (!a || a === document.body || a === document.documentElement || !a.isConnected) return true;
    var drawer = a.closest && a.closest('facet-drawer');
    if (!drawer) return false;                      /* focus pus de utilizator in alta parte */
    var summary = drawer.querySelector(':scope > details > summary');
    return a !== summary;                           /* focus ramas in interiorul panoului inchis */
  }

  function restore() {
    if (document.body.classList.contains('facet-drawer--open')) return; /* s-a redeschis */
    if (!focusLost()) return;
    var s = opener();
    if (s) s.focus({ preventScroll: true });
  }

  /* 2. Sterge (bara principala): dupa ce tema goleste filtrele si re-randeaza
     rezultatele, inchidem panoul prin evenimentul temei drawer:force-close */
  document.addEventListener('click', function (e) {
    var clear = e.target.closest && e.target.closest('.mobile-facets__main > .mobile-facets__footer facet-remove');
    if (!clear) return;
    var drawer = clear.closest('facet-drawer');
    var start = Date.now();
    (function waitCleared() {
      var cleared = location.search.indexOf('filter.') === -1;
      var busy = document.querySelector('.facets-container .loading-overlay:not(.hidden), .collection.loading');
      if ((cleared && !busy) || Date.now() - start > 4000) {
        var d = document.querySelector('facet-drawer') || drawer;
        if (document.body.classList.contains('facet-drawer--open') && d) {
          d.dispatchEvent(new CustomEvent('drawer:force-close'));
        }
        return;
      }
      setTimeout(waitCleared, 150);
    })();
  }, true);

  /* 1. 'close' e dispatch-uit de MenuDrawer.closeMenuDrawer pe <facet-drawer>
     si nu face bubble, deci il prindem in faza de capture */
  document.addEventListener('close', function (e) {
    if (!e.target || e.target.tagName !== 'FACET-DRAWER') return;
    [60, 450, 1000].forEach(function (t) { setTimeout(restore, t); });
  }, true);
})();
